// SP-1437: Collection description see-more/see-less toggle
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 768;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getLineHeight(el) {
    // Read from the first <p> child — the container div may inherit a different
    // computed value than what the RTE paragraph actually renders at.
    var target = el.querySelector('p') || el.firstElementChild || el;
    var lh = parseFloat(getComputedStyle(target).lineHeight);
    return isNaN(lh) || lh <= 0 ? 24 : lh;
  }

  // scrollHeight for an overflow:hidden container includes container padding AND
  // child margins (collapse is blocked). Strip all three so we compare only
  // rendered text height against the 3-line threshold.
  function getContentHeight(el) {
    var height = el.scrollHeight;
    var cs = getComputedStyle(el);
    height -= (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var first = el.firstElementChild;
    var last = el.lastElementChild;
    if (first) height -= parseFloat(getComputedStyle(first).marginTop) || 0;
    if (last)  height -= parseFloat(getComputedStyle(last).marginBottom) || 0;
    return height;
  }

  function initSection(wrapper) {
    var content = wrapper.querySelector('[data-description-content]');
    var toggleBtn = wrapper.querySelector('[data-description-toggle]');
    if (!content || !toggleBtn) return;

    var isDesktopOnly = wrapper.classList.contains('collection-description--desktop-only');
    var isMobileOnly = wrapper.classList.contains('collection-description--mobile-only');
    var isBoth = wrapper.classList.contains('collection-description--both');

    function initializeToggle() {
      content.style.maxHeight = '';
      content.classList.remove('expanded', 'no-toggle');
      toggleBtn.style.display = '';
      toggleBtn.setAttribute('aria-expanded', 'false');

      var shouldShowToggle = isBoth
        || (isDesktopOnly && !isMobile())
        || (isMobileOnly && isMobile());

      if (!shouldShowToggle) {
        content.classList.add('no-toggle');
        return;
      }

      var collapsedHeight = getLineHeight(content) * 3;

      if (getContentHeight(content) <= collapsedHeight) {
        content.classList.add('no-toggle');
        return;
      }

      content.style.maxHeight = collapsedHeight + 'px';
      toggleBtn.style.display = 'inline-block';
    }

    function onToggle() {
      var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';

      if (!isExpanded) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = getLineHeight(content) * 3 + 'px';
      }

      toggleBtn.setAttribute('aria-expanded', String(!isExpanded));
      content.classList.toggle('expanded', !isExpanded);
    }

    toggleBtn.addEventListener('click', onToggle);
    initializeToggle();

    // Only device-specific modes need a resize listener;
    // "both" is always active so no viewport crossing to handle
    if (isDesktopOnly || isMobileOnly) {
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initializeToggle, 250);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-collection-description]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: re-init when the section is reloaded
  document.addEventListener('shopify:section:load', function (event) {
    var wrapper = event.target.querySelector('[data-collection-description]');
    if (wrapper) initSection(wrapper);
  });
})();
